export default __webpack_public_path__ + "static/media/What-is-ALS.ff696252.jpg";